import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { client } from './apollo/client';
import ShipList from './components/ShipList';
import ShipDetail from './components/ShipDetail';
import PassagePlanDetail from './components/PassagePlanDetail';
import ShipSearch from './components/ShipSearch';
import PassagePlanSearch from './components/PassagePlanSearch';
import Readme from './components/Readme';
import './App.css';

function App() {
  return (
    <ApolloProvider client={client}>
      <Router>
        <div className="App">
          <header className="App-header">
            <h1>
              <img src="/favicon.png" alt="Sail Alert" className="header-icon" />
              Sail Alert URAGA
            </h1>
            <p>浦賀水道航路船舶航行情報</p>
            <Link to="/readme" className="readme-link">注意(最初にお読み下さい)</Link>
          </header>
          <main className="App-main">
            <Routes>
              <Route path="/" element={<ShipList />} />
              <Route path="/readme" element={<Readme />} />
              <Route path="/search" element={<ShipSearch />} />
              <Route path="/passage-plan-search" element={<PassagePlanSearch />} />
              <Route path="/ship/:shipId" element={<ShipDetail />} />
              <Route path="/passage-plan/:passagePlanId" element={<PassagePlanDetail />} />
            </Routes>
          </main>
        </div>
      </Router>
    </ApolloProvider>
  );
}

export default App;
